import { Analytics, getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

import { isAnalyticsEnabled } from 'services/analytics/analyticsConfig';

const firebaseConfig = {
  apiKey: 'AIzaSyApWtkx4FwLvnlGgQ-C1Y0_qqQSgDo_xy4',
  authDomain: 'clube-42-3baa5.firebaseapp.com',
  projectId: 'clube-42-3baa5',
  storageBucket: 'clube-42-3baa5.firebasestorage.app',
  messagingSenderId: '352148083479',
  appId: '1:352148083479:web:899625a7a6ebe6b4771d52',
  measurementId: 'G-CLFEG6TC5P',
};

const firebaseClient = initializeApp(firebaseConfig);
const analytics: Analytics | null =
  typeof window !== 'undefined' && isAnalyticsEnabled()
    ? getAnalytics(firebaseClient)
    : null;
const auth = getAuth(firebaseClient);
const firestore = getFirestore(firebaseClient);
const googleProvider = new GoogleAuthProvider();

export { firebaseClient, analytics, auth, firestore, googleProvider };
